export default {
  id: 'teams_promote_content_shares',
  title: 'Promote content shares',
  type: 'Direct / Channel',
  canSendToChannel: true,
  relations: [ 'MANY_CONTENT' ],
  description: 'Send up to 4 selected pieces of content to your employees so they can easily share them across their network.',
  body: {
    attachments: [ {
      id: 'return-button',
      contentType: 'application/vnd.microsoft.card.adaptive',
      name: null,
      thumbnailUrl: null,
      contentUrl: null,
      content: JSON.stringify({
        type: 'AdaptiveCard',
        $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
        version: '1.4',
        body: [
          {
            type: 'ColumnSet',
            columns: [
              {
                type: 'Column',
                width: 1,
                items: [
                  {
                    type: 'TextBlock',
                    text: 'Go to the platform to check out more content.',
                    wrap: true
                  },
                ]
              }
            ]
          }
        ],
        actions: [
          {
            type: 'Action.OpenUrl',
            title: 'Visit Platform for More',
            style: 'positive',
            url: '{{PLATFORM_LINK}}'
          }
        ]
      })
    } ],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <BLOCK_CONTENT>
        <attachment id='return-button'></attachment>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  blocks: {
    BLOCK_CONTENT: id => `<attachment id='${id}'></attachment>`,
  },
  attachment(id, contentShareType = 'default') {
    let content = {};
    const generateContent = (items) => ({
      type: 'AdaptiveCard',
      version: '1.5',
      $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
      body: [
        {
          type: 'Container',
          separator: true,
          items: [
            {
              type: 'ColumnSet',
              columns: [
                {
                  type: 'Column',
                  width: 'stretch',
                  items: [
                    {
                      type: 'TextBlock',
                      text: '{{CONTENT_[ID]_TITLE}}',
                      wrap: true,
                      weight: 'Bolder',
                      size: 'Medium'
                    },
                    {
                      type: 'TextBlock',
                      text: '{{CONTENT_[ID]_DESCRIPTION}}',
                      wrap: true
                    }
                  ]
                },
                {
                  type: 'Column',
                  width: 'auto',
                  items: [
                    {
                      type: 'Image',
                      url: '{{CONTENT_[ID]_IMAGE_URL}}',
                      size: 'Medium',
                      altText: '{{CONTENT_[ID]_TITLE}}'
                    }
                  ]
                }
              ]
            },
            ...items
          ]
        },
      ],
      msTeams: {
        width: 'Full'
      }
    });
    if (contentShareType === 'linkedin-only') {
      content = generateContent([
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'Share on LinkedIn',
              url: '{{CONTENT_[ID]_LINKEDIN_SHARE_LINK}}'
            }
          ]
        }
      ]);
    } else {
      content = generateContent([
        {
          type: 'TextBlock',
          text: '[[INPUT_SHARE_TEXT_TITLE]]',
          wrap: true,
          weight: 'Bolder'
        },
        {
          type: 'TextBlock',
          text: '{{CONTENT_[ID]_SHARE_TEXT}}',
          wrap: true,
          isSubtle: true,
          spacing: 'Small'
        },
        {
          type: 'TextBlock',
          text: '[[INPUT_SHARE_TEXT_REMINDER]]',
          wrap: true,
          isSubtle: true,
          size: 'Small',
          spacing: 'Small'
        },
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'LinkedIn',
              url: '{{CONTENT_[ID]_LINKEDIN_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Facebook',
              url: '{{CONTENT_[ID]_FACEBOOK_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'X',
              url: '{{CONTENT_[ID]_TWITTER_SHARE_LINK}}'
            }
          ]
        },
        {
          type: 'ActionSet',
          actions: [
            {
              type: 'Action.OpenUrl',
              title: 'Messenger',
              url: '{{CONTENT_[ID]_MESSENGER_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'WhatsApp',
              url: '{{CONTENT_[ID]_WHATSAPP_SHARE_LINK}}'
            },
            {
              type: 'Action.OpenUrl',
              title: 'Copy Share Link',
              url: '{{CONTENT_[ID]_COPY_SHARE_LINK}}'
            }
          ]
        }
      ]);
    }
    const attachment = {
      id,
      contentType: 'application/vnd.microsoft.card.adaptive',
      name: null,
      thumbnailUrl: null,
      contentUrl: null,
      content: JSON.stringify(content)
    };

    return attachment;
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following pieces of content with your network to win rewards! ...',
      defaultValue: 'Share the following pieces of content with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_SHARE_TEXT_REMINDER: {
      label: 'Share Text Reminder',
      placeholder: '👆 Copy the text above to share with your network',
      defaultValue: '👆 Copy the text above to share with your network',
      type: 'STRING'
    },
    INPUT_SHARE_TEXT_TITLE: {
      label: 'Share Text Title',
      placeholder: 'Suggested Share Text:',
      defaultValue: 'Suggested Share Text:',
      type: 'STRING'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/applus/promoteContentShares.js